import React from 'react';
import { connect } from 'react-redux';
import { history } from '../store';
import '../styles/ManualsView.css';

const MANUAL_ICONS = {
  Cash: 'fa-cash-register',
  Incidences: 'fa-exclamation-triangle',
  Management: 'fa-cogs',
  TechnicalRequirements: 'fa-clipboard-list',
  TroubleShooting: 'fa-tools',
  User: 'fa-user-circle',
  TechnicalSpecs: 'fa-microchip',
};

const MANUAL_DESCRIPTIONS = {
  Cash: 'Gestión de efectivo y arqueos',
  Incidences: 'Registro y resolución de incidencias',
  Management: 'Administración general del sistema',
  TechnicalRequirements: 'Requisitos técnicos de instalación',
  TroubleShooting: 'Resolución de problemas comunes',
  User: 'Guía de uso para operadores',
  TechnicalSpecs: 'Especificaciones técnicas del hardware',
};

class ManualsView extends React.Component {
  constructor(props) {
    super(props);
    this.manuals = [
      'Cash',
      'Incidences',
      'Management',
      'TechnicalRequirements',
      'TroubleShooting',
      'User',
      'TechnicalSpecs',
    ];
  }

  goTo(id, e) {
    history.push(`/manuals/${id}`);
  }

  render() {
    return (
      <div className="manuals-view">
        {/* Admin Header */}
        <div className="mn-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-book mr-3"></i>
                MANUALES
              </h1>
            </div>
          </div>
        </div>

        {/* Manuals List Card */}
        <div className="manuals-section-card">
          <div className="manuals-section-header">
            <i className="fas fa-list"></i>
            Documentación Disponible
          </div>
          <div className="manuals-section-body">
            {this.manuals.map((name) => {
              const label = name.replace(/([A-Z])/g, ' $1').trim();
              const icon = MANUAL_ICONS[name] || 'fa-file-pdf';
              const description = MANUAL_DESCRIPTIONS[name] || '';

              return (
                <div key={name} className="manual-item">
                  <div className="manual-item-icon">
                    <i className={`fas ${icon}`}></i>
                  </div>
                  <div className="manual-item-info">
                    <p className="manual-item-title">{label}</p>
                    <p className="manual-item-subtitle">{description}</p>
                  </div>
                  <div className="manual-item-langs">
                    <button
                      className="manual-lang-btn"
                      onClick={() => this.goTo(`Manual${name}_es`)}
                      title={`${label} — Español`}
                    >
                      <span className="lang-flag">🇪🇸</span>
                      <span className="lang-label">ES</span>
                    </button>
                    <button
                      className="manual-lang-btn"
                      onClick={() => this.goTo(`Manual${name}_en`)}
                      title={`${label} — English`}
                    >
                      <span className="lang-flag">🇬🇧</span>
                      <span className="lang-label">EN</span>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  error: state.audits.error,
  loading: state.audits.loading,
  form: state.form,
});

export default connect(mapStateToProps)(ManualsView);
